module.exports = __webpack_public_path__ + "img/arrow_back.6729d1a5.svg";